import { SCENARIOS } from "../lib/scenario";

export default function ScenarioToggle({ value, onChange }) {
  return (
    <div className="inline-flex border border-[var(--rule-strong)] bg-white" data-testid="scenario-toggle">
      {Object.values(SCENARIOS).map((s) => (
        <button
          key={s.id}
          onClick={() => onChange(s.id)}
          className={`px-3 py-1.5 text-[11px] font-display tracked-tight uppercase border-r last:border-r-0 border-[var(--rule-strong)] ${
            value === s.id
              ? "bg-[var(--ink)] text-white"
              : "text-[var(--muted-fg)] hover:bg-[var(--paper-soft)]"
          }`}
          data-testid={`scenario-${s.id}`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
